import ErrorIcon from "@mui/icons-material/ErrorRounded";
import { Stack, Tooltip } from "@mui/material";
import TabLabelWithCount from "../../../common/TabLabelWithCount";

interface Props {
  label: string;
  count?: number;
  isActive?: boolean;
  incompleteHint?: string;
}

const InvestorCommunicationTabLabel = ({ label, count, isActive, incompleteHint }: Props) => (
  <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
    <TabLabelWithCount
      label={label}
      count={count ?? 0}
      isActive={isActive}
      hideCounter={count === undefined}
      showZero
    />
    {incompleteHint && (
      <Tooltip arrow title={incompleteHint}>
        <ErrorIcon color="warning" />
      </Tooltip>
    )}
  </Stack>
);

export default InvestorCommunicationTabLabel;
